import { TERMS_AND_CONDITIONS } from 'common/actions/termsAndConditions';

const initialState = {};

export const termsAndConditionsReducer = (state = initialState, action) => {
  switch (action.type) {
    case TERMS_AND_CONDITIONS.FETCH.SUCCESS:
      return action.payload.termsAndConditions;

    default:
      return state;
  }
};
